import { render, staticRenderFns } from "./userManual_h5.vue?vue&type=template&id=5dff9664&scoped=true"
import script from "./userManual_h5.vue?vue&type=script&lang=js"
export * from "./userManual_h5.vue?vue&type=script&lang=js"
import style0 from "./userManual_h5.vue?vue&type=style&index=0&id=5dff9664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff9664",
  null
  
)

export default component.exports